/**
 * Krok UI4 — admin klient webu kanceláře (SR6, `/w/<slug>`).
 *
 * Jádro (nárok podle ročního tarifu, roster makléřů, nabídky) je hotové od
 * SR6 — tenhle soubor jen zavolá `/v1/crm/office-site`.
 */

import type { ApiPaths } from '@reos/api-client';
import { apiClient } from './api.js';
import { unwrap } from './api-error.js';

export type OfficeSite = NonNullable<
  ApiPaths['/v1/crm/office-site']['get']['responses']['200']['content']['application/json']
>;

/** `null` = web kanceláře ještě nikdy nebyl zapnutý. */
export function fetchOfficeSite(): Promise<OfficeSite | null> {
  return unwrap(apiClient.GET('/v1/crm/office-site', {}));
}

/** Zapnutí — server sám ověří nárok (roční tarif); bez něj `OfficeSiteError` (problem+json 403). */
export function enableOfficeSite(): Promise<OfficeSite> {
  return unwrap(apiClient.POST('/v1/crm/office-site', {}));
}

/**
 * Krok DOM1 — vlastní doména webu kanceláře. Návod pro DNS (cíl CNAME, IP
 * adresy, název TXT) chodí ZE SERVERU spolu se seznamem domén: adresy se
 * mohou změnit přesunem serveru a kancelář by podle textu z bundlu
 * nastavila DNS do prázdna.
 */
export type OfficeDomainList =
  ApiPaths['/v1/crm/office-domains']['get']['responses']['200']['content']['application/json'];
export type OfficeDomain = OfficeDomainList['items'][number];

export function fetchOfficeDomains(): Promise<OfficeDomainList> {
  return unwrap(apiClient.GET('/v1/crm/office-domains', {}));
}

export function addOfficeDomain(domain: string): Promise<OfficeDomain> {
  return unwrap(apiClient.POST('/v1/crm/office-domains', { body: { domain } }));
}

/** Tlačítko „Ověřit" — tentýž krok jako plánovač ve workeru, jen hned. */
export function verifyOfficeDomain(id: string): Promise<OfficeDomain> {
  return unwrap(apiClient.POST('/v1/crm/office-domains/{id}/verify', { params: { path: { id } } }));
}

export function removeOfficeDomain(id: string): Promise<unknown> {
  return unwrap(apiClient.DELETE('/v1/crm/office-domains/{id}', { params: { path: { id } } }));
}
